import PayloadStrategy from "./PayloadStrategy";

class Download extends PayloadStrategy {
	constructor(download) {
		super();

		this.report_type = download.report_type || "";
		this.date_init = download.date_init || null;
		this.date_end = download.date_end || null;
		this.resource_id = download.resource_id || null;

		this.id = download.id || null;
		this.added_on = download.added_on || null;
		this.update_on = download.update_on || null;
		this.bucket_path = download.bucket_path || "";
		this.original_name = download.original_name || "";
		this.process_id = download.process_id || null;
		this.resource_generated = download.resource_generated || false;
		this.is_public = download.is_public || false;
	}

	validate() {
		if (!this.report_type) return "report_type";
		if (!this.date_init) return "date_init";
		if (!this.date_end) return "date_end";
		if (!this.resource_id) return "resource_id";
		return null;
	}

	payloadToCreate() {
		return {
			report_type: this.report_type,
			date_init: this.date_init,
			date_end: this.date_end,
			resource_id: this.resource_id,
		};
	}

	payloadToUpdate() {
		return {
			report_type: this.report_type,
			date_init: this.date_init,
			date_end: this.date_end,
			resource_id: this.resource_id,
			bucket_path: this.bucket_path,
			original_name: this.original_name,
			process_id: this.process_id,
			resource_generated: this.resource_generated,
			is_public: this.is_public,
		};
	}

	payloadToFetch() {
		return [
			"id",
			"report_type",
			"date_init",
			"date_end",
			"resource_id",
			"added_on",
			"update_on",
			"bucket_path",
			"original_name",
			"process_id",
			"resource_generated",
			"is_public",
		];
	}
}

export default Download;
